import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';

export interface RedeemClaimRequest {
  claimId: string;
  claimAssetId: string;
}

export interface RedeemClaimResponse {
  ok: boolean;
  plan: string;
  plan_end_date: string;
}

const microClaimApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    redeemMicroClaim: builder.mutation<RedeemClaimResponse, RedeemClaimRequest>({
      query: (body) => ({
        url: apiRoutes.microClaimRedeem,
        method: 'POST',
        body
      })
    })
  })
});

export const { useRedeemMicroClaimMutation } = microClaimApi;
